<template>
   <div class="overflow-hidden v-card v-sheet theme--light mt-0" style="background: #F3F3F3; height: 100vh;">
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <div class="component-container">
  
      <div class="alert-container">
        <div class="work-progress">
         <span v-if="action_update === 'support'"><b>If any queries</b></span>
          <span v-else><b>Work Inprogress</b></span>
        </div>
        <div style="text-align: center;">
          <span>Please contact blubirch product support team <b style="color: #1976d2;">{{this.organization_name}}support@blubirch.com</b></span>
        </div>
      </div>
    </div>
    </div>
  </template>
  <script>
  import HeaderComponent from "@/components/commoncomponents/HeaderComponent";
  export default {
    data(){
      return{
        headerText : 'Support',
        action_update: '',
      }
    },
    created() {
      this.organization_name = this.$store.state.organization_name;
      this.action_update = this.$route.query.support;
    },
    watch:{
        '$route.query.support': function(newTab) {
            this.action_update = newTab
          },

    },
    components: {
      HeaderComponent
    },
  }
  
  </script>
  <style scoped>
  .component-container {
    position: relative;
    width: 100%;
  }
  
  .alert-container {
    position: absolute;
    top: 30vh;
    left: 50%; 
    transform: translate(-50%, -50%); 
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 9999; 
  }
  .work-progress{
    text-align: center;
    margin-bottom: 10px;
    font-size: 25px;
  }
  </style>